import {gql} from '@apollo/client'

export const GET_ALL_QUOTES = gql`
  query allQuotes(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $archived: Boolean
    $createdBefore: Date
    $createdAfter: Date
    $effectiveDateBefore: Date
    $effectiveDateAfter: Date
    $completedBefore: Date
    $completedAfter: Date
    $canceledBefore: Date
    $canceledAfter: Date
    $archivedBefore: Date
    $archivedAfter: Date
    $carrier: [String]
    $stateEU: [String]
    $stateJurisdictionType: String
    $policyType: [String]
    $leadSource: [String]
    $status: [String]
    $documentStatus: [String]
    $paymentStatus: [String]
    $metalLevel: String
    $isImportant: Boolean
    $user: [String]
    $assignedTo: [String]
    $zipCode: String
    $holderName: String
    $insuranceCategory: String
    $effectiveYear: [String]
    $immigrationStatus: [String]
    $orderBy: String
    $orderDirection: String
    $includeTotals: Boolean = false
  ) {
    allQuotes(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      archived: $archived
      createdBefore: $createdBefore
      createdAfter: $createdAfter
      effectiveDateBefore: $effectiveDateBefore
      effectiveDateAfter: $effectiveDateAfter
      completedBefore: $completedBefore
      completedAfter: $completedAfter
      canceledBefore: $canceledBefore
      canceledAfter: $canceledAfter
      archivedBefore: $archivedBefore
      archivedAfter: $archivedAfter
      carrier: $carrier
      stateEU: $stateEU
      stateJurisdictionType: $stateJurisdictionType
      policyType: $policyType
      leadSource: $leadSource
      status: $status
      documentStatus: $documentStatus
      paymentStatus: $paymentStatus
      metalLevel: $metalLevel
      isImportant: $isImportant
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      holderName: $holderName
      insuranceCategory: $insuranceCategory
      effectiveYear: $effectiveYear
      immigrationStatus: $immigrationStatus
      orderBy: $orderBy
      orderDirection: $orderDirection
      includeTotals: $includeTotals
    ) {
      pageInfo {
        hasNextPage
        endCursor
        startCursor
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          id
          created
          updated
          policyName
          applicants
          NPN
          effectiveDate
          memberId
          planName
          metalLevel
          premium
          status
          zipCode
          stateEU {
            code
          }
          user {
            id
            firstName
            lastName
            email
            cellphone
            avatar
          }
          carrier {
            id
            name
          }
          holderMember {
            id
            firstName
            lastName
            phone
            rol
          }
          assignedTo {
            id
            firstName
            lastName
          }
          archivedDate
          isImportant
          blockedDate
          commissionPayable
        }
      }
    }
  }
`
